import React from 'react';
import styles from './form-container.module.css';

const FormContainer: React.FC = (props) => {
	return (
		<div className="cyber-main">
			<div className="cyber-spacer section"></div>
			<div className="cyber-container max-width-1000">
				<div className={styles.form}>{props.children} </div>
			</div>
			<div className="cyber-spacer section"></div>
		</div>
	);
};

export default FormContainer;
